import { TabWrap } from 'sections/TabWrap';

import { usePermissions } from './Permissions.hooks';

const Permissions = () => {
  const { sections } = usePermissions();

  return <TabWrap sections={sections} />;
};

export { Permissions };
